import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { GroupService } from '../../services/group.service';
import { ProjectService } from '../../services/project.service';
import { Group } from '../../dtos/group';
import { Project } from '../../dtos/project';
import { Router } from '@angular/router';
import { stageToChildRoute } from '../../dtos/project-state';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false,
})
export class HomeComponent implements OnInit {
  readonly workflowStages = [
    {
      number: 1,
      title: 'Project Setup',
      description: 'Define questions, criteria, and invite your team',
    },
    {
      number: 2,
      title: 'Paper Import',
      description: 'Import from OpenAlex, BibTeX, or PDF upload',
    },
    {
      number: 3,
      title: 'Title Screening',
      description: 'Screen by title & abstract with multiple reviewers',
    },
    {
      number: 4,
      title: 'Full-Text Review',
      description: 'Retrieve PDFs and screen full papers in depth',
    },
    {
      number: 5,
      title: 'Data Extraction',
      description: 'Extract structured data with custom schemas',
    },
    { number: 6, title: 'Completion', description: 'Export results and finalize your review' },
  ];

  showGroupModal = false;
  groups: Group[] = [];
  projects: Project[] = [];
  loading = false;

  constructor(
    public authService: AuthService,
    private groupService: GroupService,
    private projectService: ProjectService,
    private router: Router,
  ) {}

  ngOnInit() {
    if (this.authService.isLoggedIn()) {
      this.loadData();
    }
  }

  private loadData(): void {
    this.loading = true;
    this.groupService.getGroups().subscribe({
      next: (groups) => {
        this.groups = groups;
        if (this.groups.length > 0) {
          this.loadProjects();
        } else {
          this.loading = false;
        }
      },
      error: (err) => {
        console.error('Error loading groups:', err);
        this.loading = false;
      },
    });
  }

  private loadProjects(): void {
    this.projectService.getProjectsPaginated(0, 6).subscribe({
      next: (res) => {
        this.projects = res.items;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading projects:', err);
        this.loading = false;
      },
    });
  }

  onGroupCreated(group: any) {
    console.log('Group created', group);
    // Toast is shown in the group-modal component
    this.loadData();
  }

  viewProject(project: Project): void {
    const route = stageToChildRoute(project.state);
    const segments = route ? ['/projects', project.id, route] : ['/projects', project.id];
    this.router.navigate(segments);
  }

  viewGroup(group: Group): void {
    this.router.navigate(['/groups', group.id]);
  }

  viewGroupProjects(): void {
    this.router.navigate(['/projects']);
  }
}
